import React from 'react';
import { useTranslation } from 'react-i18next';
import { Button, Divider, Flex } from '@chakra-ui/core';
import { RecruiterList, RecruiterListProps } from './RecruiterList';
import PositionSearch from './PositionSearch';

interface Props extends RecruiterListProps {
  clearSearch: () => void;
}

function RecruiterTab({
  recruiters,
  checkedRecruiters,
  handleCheckedRecruiters,
  getStyleForAvailabilityByUser,
  clearSearch,
}: Props) {
  const { t } = useTranslation('calendar');
  const [search, setSearch] = React.useState<string>('');

  return (
    <React.Fragment>
      <PositionSearch
        value={search}
        onChange={(value) => setSearch(value)}
        placeholder={t('administration:calendar.sidebarRecruiterSearchPlaceholder')}
      />

      <Divider borderColor="gray.100" />
      <Flex justifyContent="end" px={4} py={2}>
        <Button
          colorScheme="blue"
          variant="link"
          size="xs"
          data-testid="ClearBtn"
          onClick={() => {
            setSearch('');
            clearSearch();
          }}
          _focus={{
            boxShadow: 'none',
          }}
        >
          {t('administration:calendar.sidebarPositionClearAll')}
        </Button>
      </Flex>
      <Divider borderColor="gray.100" />
      <RecruiterList
        recruiters={recruiters}
        getStyleForAvailabilityByUser={getStyleForAvailabilityByUser}
        searchText={search}
        handleCheckedRecruiters={handleCheckedRecruiters}
        checkedRecruiters={checkedRecruiters}
      />
    </React.Fragment>
  );
}

export default React.memo(RecruiterTab);
